export default __webpack_public_path__ + "static/media/placeholder_dummy2016-beauty01-de.92b4db98.png";